import { HTTP } from '@/services/axios';

export async function getGroups({filterText,orderCol,orderSort,page,records}){
    let result = {};
    
    await HTTP.get('/app/core/Group/getGroupList.php',{
        params:{
            filterText,
            orderCol,
            orderSort,
            page,
            records
        }
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getGroup({groupId}){
    let result = {};
   
    await HTTP({
        method: 'get',
        url: `/app/core/Group/getGroupData.php?groupId=${groupId}`,
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });
    return result;
}

export async function getGroupOptions(){
    let result = [];
    
    await HTTP({
        method: 'get',
        url: '/app/core/Group/getGroupOptions.php'
    })
    .then(response => {
        result = response.data.result;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function unlockGroup({groupId}){
    let result = {};

    var data = {'myRecordID':groupId};
    
    await HTTP({
        method: 'patch',
        url: '/app/core/Group/controlGroupUnlock.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function createGroup({data}){
    let result = {};

    await HTTP({
        method: 'post',
        url: '/app/core/Group/controlGroupSave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function saveGroup({data}){
    let result = {};

    await HTTP({
        method: 'put',
        url: '/app/core/Group/controlGroupSave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function deleteGroup({data}){
    let result = {};

    await HTTP({
        method: 'delete',
        url: '/app/core/Group/controlGroupDelete.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

//authorization to group
export async function getAuthorizationsToGroup({groupId}){
    let result = {};

    await HTTP({
        method: 'get',
        url: `/app/core/Group/getAuthorizationData.php?groupId=${groupId}`
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}



export async function saveAuthorizationsToGroup({authorizations,groupId}){
    let result = {};

    var data = {'groupId':groupId,'myAuthorizations':authorizations};
    
    await HTTP({
        method: 'patch',
        url: '/app/core/Group/controlGroupAuthorizationSave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}